var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dataArrayChunk } from "@smp/utils";
import parseISO from "date-fns/parseISO";
import { ApiEpPageconfig, ApiEpPageconfigaccount, } from "../../ep";
import { apiRecursive } from "../../lib";
import { ApiSmpAccountCredentials, ApiSmpPage, } from "../../smp";
const helperPageContainerListFromAccountCredential = ({ accountCredential, accountCredentialFacebookList, pageList, pageconfigList, pageconfigaccountList, subscriptionList, }) => {
    const subscriptionListCurrent = subscriptionList.filter((subscription) => subscription.subject === accountCredential.account_page_id);
    const pageIdListCurrent = [
        ...subscriptionListCurrent.map((subscription) => subscription.target),
        accountCredential.account_page_id,
    ];
    return pageIdListCurrent.map((pageId) => {
        const page = pageList.find((page) => page.id === pageId);
        const subscriptionCurrent = subscriptionList.find((subscription) => subscription.target === page.id &&
            subscription.subject === accountCredential.account_page_id);
        const pageconfigListCurrent = pageconfigList.filter((pageconfig) => `${pageconfig.medium}:${pageconfig.external_id}` ===
            `${page.medium}:${page.external_id}`);
        const pageconfigContainerList = pageconfigListCurrent
            .map((pageconfig) => ({
            pageconfig,
            pageconfigaccount: pageconfigaccountList.find((pageconfigaccount) => pageconfigaccount.page_config === pageconfig.id),
        }))
            .sort((a, b) => {
            if (!a.pageconfigaccount)
                return 1;
            if (!b.pageconfigaccount)
                return -1;
            if (parseISO(a.pageconfigaccount.updated_at) >
                parseISO(b.pageconfigaccount.updated_at))
                return -1;
            if (parseISO(a.pageconfigaccount.updated_at) <
                parseISO(b.pageconfigaccount.updated_at))
                return 1;
            return 0;
        });
        const isConnected = pageconfigContainerList.some((pageconfigContainer) => !!pageconfigContainer.pageconfigaccount);
        const isNew = pageconfigContainerList.length < 1;
        const hasPermissionsLocal = (() => {
            const pageconfigaccountList = pageconfigContainerList
                .filter((pageconfigContainer) => pageconfigContainer.pageconfigaccount)
                .map((pageconfigContainer) => pageconfigContainer.pageconfigaccount);
            return pageconfigaccountList.every((pageconfigaccount) => pageconfigaccount === null || pageconfigaccount === void 0 ? void 0 : pageconfigaccount.has_publish_permission);
        })();
        const hasPermissionsRemote = (() => {
            const permissions = [];
            if (page.medium === "facebook" && page.type === "public") {
                permissions.push(accountCredentialFacebookList.some((accountCredential) => accountCredential.account_page_id === page.id &&
                    accountCredential.permissions.includes("posts")));
            }
            else {
                if (subscriptionCurrent) {
                    permissions.push(subscriptionCurrent.permission.includes("manage_content"));
                }
                if (page.id === accountCredential.account_page_id) {
                    permissions.push(accountCredential.permissions.includes("posts"));
                }
            }
            return permissions.every((permission) => !!permission);
        })();
        return {
            hasPermissionsLocal,
            hasPermissionsRemote,
            isConnected,
            isNew,
            page,
            pageconfigContainerList,
        };
    });
};
export const AccountContainer = {
    list: (req) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const accountCredentialList = yield apiRecursive(ApiSmpAccountCredentials.list, [
            {
                query: {
                    id__in: (_a = req === null || req === void 0 ? void 0 : req.query) === null || _a === void 0 ? void 0 : _a.id__in,
                    is_lost: (_b = req === null || req === void 0 ? void 0 : req.query) === null || _b === void 0 ? void 0 : _b.is_lost,
                    medium: (_c = req === null || req === void 0 ? void 0 : req.query) === null || _c === void 0 ? void 0 : _c.medium,
                    type__in: (_d = req === null || req === void 0 ? void 0 : req.query) === null || _d === void 0 ? void 0 : _d.type__in,
                },
            },
        ]);
        const subscriptionList = yield apiRecursive(ApiSmpPage.Subscription.list, [
            {
                query: {
                    subject__in: accountCredentialList.map((accountCredential) => accountCredential.account_page_id),
                },
            },
        ]);
        const pageList = yield apiRecursive(ApiSmpPage.listById, [
            {
                query: {
                    id__in: [
                        ...accountCredentialList.map((accountCredential) => accountCredential.account_page_id),
                        ...subscriptionList.map((subscription) => subscription.target),
                    ],
                },
            },
        ]);
        const pageFacebookPublicList = pageList.filter((page) => page.medium === "facebook" && page.type === "public");
        const accountCredentialFacebookList = !!pageFacebookPublicList.length
            ? yield apiRecursive(ApiSmpAccountCredentials.list, [
                {
                    query: {
                        account_page_id__in: pageFacebookPublicList.map((page) => page.id),
                        medium: "facebook",
                    },
                },
            ])
            : [];
        const pageconfigList = yield (() => __awaiter(void 0, void 0, void 0, function* () {
            const mediumExternalIds = pageList.map((page) => `${page.medium}:${page.external_id}`);
            const chunks = dataArrayChunk(mediumExternalIds, 100);
            const responseChunks = yield Promise.all(chunks.map((chunk) => {
                var _a;
                return apiRecursive(ApiEpPageconfig.list, [
                    {
                        query: {
                            medium_external_id__in: chunk,
                            all_organization_contexts: (_a = req === null || req === void 0 ? void 0 : req.query) === null || _a === void 0 ? void 0 : _a.all_organization_contexts,
                        },
                    },
                ]);
            }));
            return responseChunks.flatMap((resp) => resp);
        }))();
        let pageconfigaccountList = yield ApiEpPageconfigaccount.list({
            query: {
                page_config__in: pageconfigList
                    ? pageconfigList.map((pageconfig) => pageconfig.id)
                    : [],
            },
        });
        return accountCredentialList.map((accountCredential) => {
            const pageContainerList = helperPageContainerListFromAccountCredential({
                accountCredential,
                accountCredentialFacebookList,
                pageList,
                pageconfigList,
                pageconfigaccountList,
                subscriptionList,
            });
            const pageContainerListFiltered = pageContainerList.filter((pageContainer) => pageContainer.page.id !== accountCredential.account_page_id);
            const pageContainerMain = pageContainerList.find((pageContaier) => pageContaier.page.id === accountCredential.account_page_id);
            const isVisible = pageContainerMain.isConnected ||
                pageContainerListFiltered.some((pageContainer) => pageContainer.isConnected);
            return {
                accountCredential,
                isVisible,
                pageContainerList: pageContainerListFiltered,
                pageContainerMain: pageContainerMain,
            };
        });
    }),
    retrieve: (req) => __awaiter(void 0, void 0, void 0, function* () {
        var _e;
        const accountCredential = yield ApiSmpAccountCredentials.retrieve({
            path: { id: req.path.id },
        });
        const subscriptionList = yield apiRecursive(ApiSmpPage.Subscription.list, [
            {
                query: {
                    subject: accountCredential.account_page_id,
                },
            },
        ]);
        const pageList = yield apiRecursive(ApiSmpPage.listById, [
            {
                query: {
                    id__in: [
                        accountCredential.account_page_id,
                        ...subscriptionList.map((subscription) => subscription.target),
                    ],
                },
            },
        ]);
        const pageFacebookPublicList = pageList.filter((page) => page.medium === "facebook" && page.type === "public");
        const accountCredentialFacebookList = !!pageFacebookPublicList.length
            ? yield apiRecursive(ApiSmpAccountCredentials.list, [
                {
                    query: {
                        account_page_id__in: pageFacebookPublicList.map((page) => page.id),
                        medium: "facebook",
                    },
                },
            ])
            : [];
        const pageconfigList = yield apiRecursive(ApiEpPageconfig.list, [
            {
                query: {
                    medium_external_id__in: pageList
                        ? pageList.map((page) => `${page.medium}:${page.external_id}`)
                        : [],
                    all_organization_contexts: (_e = req === null || req === void 0 ? void 0 : req.query) === null || _e === void 0 ? void 0 : _e.all_organization_contexts,
                },
            },
        ]);
        const pageconfigaccountList = yield ApiEpPageconfigaccount.list({
            query: {
                page_config__in: pageconfigList
                    ? pageconfigList.map((pageconfig) => pageconfig.id)
                    : [],
            },
        });
        const pageContainerList = helperPageContainerListFromAccountCredential({
            accountCredential,
            accountCredentialFacebookList,
            pageList,
            pageconfigList,
            pageconfigaccountList,
            subscriptionList,
        });
        const pageContainerListFiltered = pageContainerList.filter((pageContainer) => pageContainer.page.id !== accountCredential.account_page_id);
        const pageContainerMain = pageContainerList.find((pageContaier) => pageContaier.page.id === accountCredential.account_page_id);
        const isVisible = pageContainerMain.isConnected ||
            pageContainerListFiltered.some((pageContainer) => pageContainer.isConnected);
        return {
            accountCredential,
            isVisible,
            pageContainerList: pageContainerListFiltered,
            pageContainerMain: pageContainerMain,
        };
    }),
};
//# sourceMappingURL=account_container.js.map